module.exports = __webpack_public_path__ + "media/images/bsmart/icons/icon_test-77f258093a718645f5e9e317fdfccd00.svg";